import React from "react";
import type { CategoryFilter } from "./types";

interface Props {
  allCategories: server.dto.ArticleCategoryTranslation[];
  articles: server.dto.Article[];
  section: server.dto.PromoSiteSections;
  onCategoryFilter: (filter: CategoryFilter) => void;
}

interface ArticleCategoryCount {
  category: server.dto.ArticleCategoryTranslation;
  articleCount: number;
}

const countCategoryArticles = (articles: server.dto.Article[], categories: server.dto.ArticleCategoryTranslation[]): ArticleCategoryCount[] => {
  return categories.reduce<ArticleCategoryCount[]>((acc, curr) => {
    const count = articles.filter(a => a.categories.some(c => c.articleCategoryId === curr.articleCategoryId)).length;

    return [...acc, { category: curr, articleCount: count }];
  }, []);
}

const CategorySidebar = (props: Props) => {

  const categoryArticleCount = countCategoryArticles(props.articles, props.allCategories)
    .sort((a, b) => a.category.title.localeCompare(b.category.title));

  const totalArticlesWithoutCategories = props.articles.filter(a => a.categories.length === 0).length;

  return <div className="padding-huge gray-100 margin-right-huge" style={{ width: 300 }}>
    <div className="flex">
      <div className="grow1">
        <a onClick={_ => props.onCategoryFilter("noFilter")}>
          All articles
        </a>
      </div>
      <div>
        {props.articles.length}</div>
    </div>
    {categoryArticleCount.map(catCount => <div key={catCount.category.articleCategoryId} className="margin-top-large flex">
      <div className="grow1">
        <a onClick={_ => props.onCategoryFilter(catCount.category.articleCategoryId)}>
          {catCount.category.title}
        </a>
      </div>
      <div>
        {catCount.articleCount}
      </div>
    </div>)}
    <div className="margin-top-large flex">
      <div className="grow1">
        <a onClick={_ => props.onCategoryFilter("noCategory")}>
          No category
        </a>
      </div>
      <div>
        {totalArticlesWithoutCategories}
      </div>
    </div>
  </div>
}

export default CategorySidebar;